var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h3',{ref:"pageHeader",staticClass:"pageHeader",style:({'--width': _vm.widthVar})},[_vm._v("教学质量评价")]),_c('div',[_c('DoGrade',{ref:"doGrade"})],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }